import { ScoreCard } from "../ScoreCard/ScoreCard";
import { Typography } from "../ui/Typography/Typography";

interface ReportMajorityMinorityCardProps {
  groupLabelKey: "majority" | "minority";
  score?: number;
  count?: number;
  isUnderThreshold: boolean;
  t: (key: string, options?: any) => string;
}

export const ReportMajorityMinorityCard = ({
  groupLabelKey,
  score,
  count,
  isUnderThreshold,
  t,
}: ReportMajorityMinorityCardProps) => (
  <div className="ReportMajorityMinority__scoreSection">
    {isUnderThreshold ? (
      <div className="ReportMajorityMinority__scoreSection__threshold">
        <Typography
          tagVariant="h3"
          desktop="h3"
          className="ReportMajorityMinority__scoreSection__threshold__title"
        >
          {t(`majorityMinorityGroups.${groupLabelKey}Group`)}
        </Typography>
        <Typography desktop="body2" color="secondary">
          {t("majorityMinorityGroups.underThreshold")}
        </Typography>
      </div>
    ) : (
      <>
        <ScoreCard
          label={t("majorityMinorityGroups.inclusionScore")}
          score={score || 0}
          scoreSize="medium"
          title={t(`majorityMinorityGroups.${groupLabelKey}Group`)}
        />
        <Typography
          desktop="label1"
          className="ReportMajorityMinority__scoreSection__count"
          color="secondary"
        >
          {t("majorityMinorityGroups.participantCount", {
            count: count || 0,
          })}
        </Typography>
      </>
    )}
    <div className="ReportMajorityMinority__scoreSection__infoBox">
      <Typography desktop="body2" color="darkerStoneBlue">
        <span
          dangerouslySetInnerHTML={{
            __html: t(`majorityMinorityGroups.${groupLabelKey}Definition`),
          }}
        />
      </Typography>
    </div>
  </div>
);
